﻿import {useEffect} from "react";
import {getQueryParamsFromPlace} from "../../util/AddressUtils";
import {useLocationSearchParams} from "./useLocationSearchParams";
import {useLocation} from "react-router";
import GeocoderResult = google.maps.GeocoderResult;

interface RedirectSearchByLocationParams {
    defaultLocation: GeocoderResult | undefined
    failedToGetByBrowserLatLng: boolean
    failedToGetByIp: boolean
    failedToGetByLocalStorage: boolean
    geocodedPlaceByBrowserLatLng: GeocoderResult | undefined
    geocodedPlaceByIpLatLng: GeocoderResult | undefined
    geocodedPlaceByLocalStorageLatLng: GeocoderResult | undefined
    geocodingAddressFromParamsFailed: boolean
}

export const useRedirectSearchByLocationParams = ({
                                                        defaultLocation,
                                                        failedToGetByBrowserLatLng,
                                                        failedToGetByIp,
                                                        failedToGetByLocalStorage,
                                                        geocodedPlaceByBrowserLatLng,
                                                        geocodedPlaceByIpLatLng,
                                                        geocodedPlaceByLocalStorageLatLng,
                                                        geocodingAddressFromParamsFailed,
                                                    }: RedirectSearchByLocationParams) => {
    const [_, setCurrentLocationParams] = useLocationSearchParams();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== '/search') return;
        if (geocodingAddressFromParamsFailed && geocodedPlaceByLocalStorageLatLng && !failedToGetByLocalStorage) {
            // URL address not valid but local storage works, redirect
            setCurrentLocationParams({
                ...getQueryParamsFromPlace(geocodedPlaceByLocalStorageLatLng, 'short_name', false)
            });
        } else if (failedToGetByLocalStorage && geocodedPlaceByBrowserLatLng && !failedToGetByBrowserLatLng) {
            // can't get from local storage, redirect to browser lat/lng
            setCurrentLocationParams({
                ...getQueryParamsFromPlace(geocodedPlaceByBrowserLatLng, 'short_name', false)
            });
        } else if(failedToGetByBrowserLatLng && geocodedPlaceByIpLatLng && !failedToGetByIp) {
            // can't get by browser lat/lng, redirect by ip
            setCurrentLocationParams({
                ...getQueryParamsFromPlace(geocodedPlaceByIpLatLng, 'short_name', false)
            });
        } else if (failedToGetByIp && defaultLocation) {
            // can't get by ip, redirect to default location
            setCurrentLocationParams({
                ...getQueryParamsFromPlace(defaultLocation, 'short_name', false)
            });
        }
    }, [defaultLocation, failedToGetByBrowserLatLng, failedToGetByIp, failedToGetByLocalStorage, geocodedPlaceByBrowserLatLng, geocodedPlaceByIpLatLng, geocodedPlaceByLocalStorageLatLng, geocodingAddressFromParamsFailed, setCurrentLocationParams, location.pathname]);
}
